import styled from '@bd/bdui-styles/emotion';
import FavoritesCategories from '../../bdcoreCandidates/Favorites';
import { colors, typography } from '../../styles';

export default styled(FavoritesCategories)`
  width: 100%;
  color: #000000;
  font-weight: 900px;
  font-size: 18px
  font-family: ${typography.SansSerif};
  position:relative;
  z-index: 6;
  @media (min-width: 992px) {
    text-transform: uppercase;
    background-size: cover;
  }
  .PageMenu_title {
    color: #FFFFFF;
    background-color: #1F1F1F;
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    height: 50px;
    position: relative;
    padding: 0 22px;
    cursor: pointer;
    height: 61px;
    font-size: 15px;
    letter-spacing: 0.47px;
    margin: 0 auto;
    position: relative;
    @media (min-width: 992px) {
      display: none;
    }
    &::after {
      content: '';
      width: 15px;
      height: 1.2px;
      background-color: ${colors.color1};
      position: absolute;
      left: calc(50% + 60px);
      transform: translateX(-50%);
    }
    &::before {
      content: '';
      width: 15px;
      height: 1.2px;
      background-color: ${colors.color1};
      transform: rotate(-270deg);
      position: absolute;
      left: calc(50% + 52px);
    }
    &:focus {
      outline: none;
    }
  }
  .PageMenu_titleAlt {
    color: #919191;
    &::before {
      content: none;
    }
  }
  .PageMenu_list {
    display: none;
    padding: 0;
    text-align: left;
    width: 100%;
    position: absolute;
    left: 0;
    top: 61px;
    list-style: none;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.25);
    background-color: #1F1F1F;
    padding: 20px 30px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 3;
    &.open {
      display: block;
    }
    @media (min-width: 992px) {
      top: auto;
      list-style: none;
      margin: 0;
      display: block;
      position: relative;
      left: auto;
      margin-left: 0;
      top: auto;
      box-shadow: none;
      text-align: center;
    }
  }
  .PageMenu_listItem {
    text-align: center;
    & + li {
      border-top: 1px solid #151515;
      @media(min-width: 992px) {
        border: 0;
        padding: 0 0 0 20px;
      }
      @media(min-width: 1300px) {
        padding: 0 0 0 30px;
      }
    }
    @media (min-width: 992px) {
      display: inline-block;
    }
    span {
      font-weight: 700;
      color: #FFFFFF;
      font-size: 16px;
      letter-spacing: 1.81px;
      line-height: 51px;
      text-align: center;
      text-transform: uppercase;
      transition: all .3s ease-out;
      cursor:pointer;
      @media(min-width: 992px) {
        font-size: 19px;
        letter-spacing: 2.71px;
        line-height: 51px;
      }
      &.active, &:hover {
        color: ${colors.color1};
        font-weight: 700;
      }
      &:focus {
        outline: none;
      }
    }
  }
  .Cards_Wrap {
    display:flex;
    flex-flow:row wrap;
    justify-content: center;
    position: relative;
    z-index: 0;
    padding-bottom: 30px;
  }
  .VideoGallery_List {
    position: relative;
    z-index: 0;
  }
  .VideoGallery_listInner{
    width: calc(100% - 15px);
    @media(min-width: 992px) {
      width: calc(50% - 30px);
      margin: 10px;
    }
    @media(min-width: 1300px) {
      width: calc(33% - 30px);
    }
  }
  .HomeFavorites_inner{
    width: calc(100% - 15px);
    @media(min-width: 992px) {
      width: calc(50% - 30px);
      margin: 10px;
    }
    @media(min-width: 1300px) {
      width: calc(33% - 20px);
    }
  }
  .PhotoCard {
    width:100%;
    position: relative;
    padding:0;
    padding-top:56%;
    background-size: cover;
    background-position: center;
  }
  .PlayIcon {
    position:absolute;
    top:50%;
    margin-top:-30px;
    left:50%;
    margin-left:-30px;
    width:60px;
    height:60px;
    border-radius: 50%;
    border:4px solid white;
    text-align: center;
    display: flex;
    flex-flow:column wrap;
    justify-content: center;
    background: rgba(0,0,0,.4);
    .PlayIcon_triangle {
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid white;
      margin: 0 auto;
    }
  }
  .FavoriteToggle {
    width: 30px;
    background: url(/images/icons/favorites-heart-outline.svg);
    height: 30px;
    background-repeat: no-repeat;
    transition: all .25s ease;
    background-position: right;
  }

  }
  .FavoriteToggle-active {
    background: url(/images/icons/favorites-heart-full.svg);
  }
  .Favorite_circle {
    width:40px;
    height:40px;
    background:rgba(0,0,0,.4);
    padding: 4px;
    position: absolute;
    top:10px;
    right:10px;
    z-index: 5;
    border-radius:50%;
    display:flex;
    flex-flow:column nowrap;
    justify-content: center;
    text-align: center;
    cursor;pointer;
    &-edit {
      right: 55px;
    }
  }
  .FavoritesActions {
    display:flex;
    flex-flow:row wrap;
    justify-content: flex-end;
    padding:10px 20px;
    position: relative;
    .FavoritesUpload_button {
      display: inline-block;
      line-height: 38px;
      height: 40px;
      margin: 0 10px 0 0;
      cursor: pointer;
      color: #FFFFFF;
      font-size: 14px;
      font-weight: 700;
      text-align: center;
      border: 0;
      padding: 0 10px;
      border-radius: 5px;
      background-color:${colors.color2};
      transition:all .25s ease;
      img {
        height: 20px;
        width: auto;
        margin: 0 10px 0 0;
      }
      &:focus, &:hover {
        outline: 0;
        box-shadow: 0;
        background-color: ${colors.color2};
        color: #FFFFFF;
      }
    }
  }

  .ClientLogin_logout .btn, .FavoritesUpload .btn {
    position: relative;
    overflow: hidden;
    height: 45px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0.12px;
    background-color: ${colors.color1};
    cursor: pointer;
    @media(min-width: 992px) {
      height: 50px;
      padding: 0 35px;
      font-size: 16px;
      letter-spacing: 0;
    }
    &:focus {
      outline: none;
    }
    &::after {
      content: '';
       position: absolute;
       top: -50%;
       right: 10%;
       bottom: -50%;
       left: -50%;
       background: linear-gradient(to bottom, rgba(0, 144, 210, 0), rgba(140, 205, 235, 0.4) 50%, rgba(0, 144, 210, 0));
       transform: rotateZ(60deg) translate(-5em, 7.5em);
    }
    &:hover::after, &:focus::after {
      animation: sheen 1s forwards;
      right: -88%;
    }
    @keyframes sheen {
      100% {
        transform: rotateZ(60deg) translate(1em, -9em);
      }
    }
  }
  .FavoriteCardWrap {
    position: relative;
  }
  .FavoriteEditWrap {
    padding:4px;
    text-align: left;
    margin-bottom: 10px;
    textarea {
      border:1px solid #B9B9B9;
      border-radius: 0;
      margin-bottom:4px;
      height: auto;
      width:100%;
      background-color: #FFFFFF;
      color: #000;
    }
  }

  .FavoritesCategories_categories {
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
  }
  .FavoritesCategories_categoriesItem {
    padding: 0;
    margin: 0;
    list-style: none;
    cursor: pointer;
    border: 1px solid ${colors.color1};

    span {
      display: block;
      padding: 15px 25px;
    }
  }
  .FavoritesCategories_list {
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
  }

  .FavoritesCategories_listItem {
    margin: 0;
    list-style: none;
    padding: 15px 25px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Favorites/FavoritesCategories.js